import { get } from 'lodash-es'

import API_CONSTANTS from '@/js/helper/api-constants.js'

import ElementPropsMixin from '@/js/mixins/element-props-mixin.js'

export default {
  mixins: [ElementPropsMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    // const component = get(this.attributes, API_CONSTANTS.ICON.ATTRIBUTE.COMPONENT)
    return {
      // link: component ? undefined : get(this.attributes, API_CONSTANTS.URL),
      link: get(this.attributes, API_CONSTANTS.URL),
      target: get(this.attributes, API_CONSTANTS.TARGET),
      title: get(this.attributes, API_CONSTANTS.TITLE),
      brand: get(this.attributes, API_CONSTANTS.BRAND.TYPE),
      pageId: get(this.attributes, API_CONSTANTS.PAGE_ID),
      badgeDate: get(this.attributes, API_CONSTANTS.BADGE_DATE),
      icon: get(this.attributes, API_CONSTANTS.ICON.NAME),
      [API_CONSTANTS.ICON.ATTRIBUTE.COMPONENT]: get(
        this.attributes,
        API_CONSTANTS.ICON.ATTRIBUTE.COMPONENT,
      ),
      // linkTiles: get(this.attributes, API_CONSTANTS.LINK_TILES, []),
    }
  },
  computed: {
    linkTiles() {
      return get(this.attributes, API_CONSTANTS.LINK_TILES, [])
    },
    componentType() {
      if (this.renderComponent && this[API_CONSTANTS.ICON.ATTRIBUTE.COMPONENT]) {
        return this[API_CONSTANTS.ICON.ATTRIBUTE.COMPONENT]
      }
      return this.link && !this.disabled ? 'BaseLink' : 'BaseSpan'
    },
  },
}
